<template>
  <div>
    <v-row>
      <v-col :cols="columns">
        <main-menu-button to="/world/the-world-in-brief">The Shattered World</main-menu-button>
        <main-menu-button to="/rules/playing-the-game">Playing the Game</main-menu-button>
        <main-menu-button to="/character-options/basic-skills">Character Options</main-menu-button>
        <main-menu-button to="/equipment">Equipment</main-menu-button>
        <main-menu-button to="/sample-characters">Sample Characters</main-menu-button>
        <!-- 
<custom-button to="/character-creator">Character Creator (WIP)</custom-button> <br /> --->
        <main-menu-button to="/search">Search</main-menu-button>
      </v-col>
      <v-col :cols="columns">
        <display-tooltip-text
          :string="welcomeText"
          style="position: static; margin: 1em" />
        <div style="justify-content: center; display: flex">
          <img
            :src="$jenna"
            class="earth-border"
            style="justify-content: center; display: flex; width: 60%" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue'
import MainMenuButton from '@/components/MainMenuButton.vue'
import WelcomeText from '@/database/text_files/welcome.txt'

export default Vue.extend({
  name: 'main-menu',
  components: {
    MainMenuButton,
  },
  computed: {
    welcomeText: function () {
      return this.$marked.parse(WelcomeText)
    },
    jennaArt: function () {
      return require('@/assets/art/Jenna.png')
    },
    columns: function () {
      if (this.isMobile) return 12
      return 6
    },
  },
})
</script>

<style scoped lang="scss">
.a {
}
</style>
